export function cleanAuth() {
  localStorage.removeItem('time')
  localStorage.removeItem('accountId')
  localStorage.removeItem('countryId')
  localStorage.removeItem('token')
  localStorage.removeItem('accessJwtToken')
  localStorage.removeItem('refreshToken')
}

export function cleanStorage() {
  cleanAuth()
  localStorage.removeItem('popUuid')
  localStorage.removeItem('tabIndex')
  localStorage.removeItem('language')
  localStorage.removeItem('CHARGESPOT::devtool')
  localStorage.removeItem('CHARGESPOT::imeiJpModal')
  localStorage.removeItem('CHARGESPOT::imeiJpLineModal')
  localStorage.removeItem('CHARGESPOT::imeiTwLineModal')
}
